import {
  CdcaApiResponse,
  GETInstrumentosFilterParams,
  CadastroCdcaApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETCdcaDetalhes,
  GETCdcas,
  POSTCdca,
  PUTCdca,
  GETCdcaDocumentDownloadUrl,
  POSTInterOpCdca,
  POSTEnviarLiquidacao,
  GETHistoricoCdca,
  POSTConfirmarLiquidacaoCdca,
  PUTUploadDoc as PUTUploadDocCdca,
  DELETEUploadDoc as DELETEUploadDocCdca,
  GETCdcaByInstrumentoId,
  PUTCdcaAditamento,
  PUTEditarCdca,
  GETAditamentoCDCA,
  PUTAditamentoCDCA
} from 'requests/cdca';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface CdcaApiState {
  getCdcaDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<CdcaApiResponse>;
  getCdcas(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CdcaApiResponse>>;
  getCdcaByInstrumentoId(dispatch: Dispatch, instrumentoId: string, stackRequest?: boolean): Promise<CdcaApiResponse>;
  postCdca(dispatch: Dispatch, cdca: CadastroCdcaApiRequest, stackRequest?: boolean): Promise<CdcaApiResponse>;
  putCdca(
    dispatch: Dispatch,
    cdcaId: string,
    cdca: CadastroCdcaApiRequest,
    stackRequest?: boolean
  ): Promise<CdcaApiResponse>;
  putCdcaAditamento(
    dispatch: Dispatch,
    CdcaId: string,
    Cdca: CadastroCdcaApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putEditarCdca(
    dispatch: Dispatch,
    cdcaId: string,
    cdca: CadastroCdcaApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putUploadDoc(
    dispatch: Dispatch,
    cdcaId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(dispatch: Dispatch, cdcaId: string, cdcaDocumentId: string, stackRequest?: boolean): Promise<unknown>;
  getCdcaDocumentDownloadUrl(
    dispatch: Dispatch,
    cdcaId: string,
    cdcaDocumentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postInterOpCdca(dispatch: Dispatch, cdca: CadastroCdcaApiRequest, stackRequest?: boolean): Promise<CdcaApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    cdcaId: string,
    cdcaSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<CdcaApiResponse>;
  postConfirmarLiquidacaoCdca(dispatch: Dispatch, cdcaId: string, precoUnitarioLiquidacao: number, stackRequest?: boolean): Promise<CdcaApiResponse>;
  getHistoricoCdca(dispatch: Dispatch, cdcaId: string, stackRequest?: boolean): Promise<Array<HistoricoResponse>>;
  getAditamentoCdca(dispatch: Dispatch, aditamentoId: string, stackRequest?: boolean): Promise<AditamentoRevisionData>;
  putAditamentoCdca(dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest?: boolean): Promise<Array<AditamentoDiferenca>>;
}

export const cdcaApiInicialState: CdcaApiState = {
  getCdcaDetalhes: GETCdcaDetalhes,
  getCdcas: GETCdcas,
  getCdcaByInstrumentoId: GETCdcaByInstrumentoId,
  postCdca: POSTCdca,
  putCdca: PUTCdca,
  putEditarCdca: PUTEditarCdca,
  putCdcaAditamento: PUTCdcaAditamento,
  putUploadDoc: PUTUploadDocCdca,
  deleteUploadDoc: DELETEUploadDocCdca,
  getCdcaDocumentDownloadUrl: GETCdcaDocumentDownloadUrl,
  postInterOpCdca: POSTInterOpCdca,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoCdca: POSTConfirmarLiquidacaoCdca,
  getHistoricoCdca: GETHistoricoCdca,
  getAditamentoCdca: GETAditamentoCDCA,
  putAditamentoCdca: PUTAditamentoCDCA,
};

enum CdcaApiActionType {
  Update = 'cdcaApi/UPDATE',
  Reset = 'cdcaApi/RESET',
}

export const updateCdcaApi = (state: CdcaApiState) => {
  return typedAction(CdcaApiActionType.Update, state);
};

export const resetCdcaApi = () => {
  return typedAction(CdcaApiActionType.Reset);
};

type CdcaApiAction = ReturnType<typeof updateCdcaApi | typeof resetCdcaApi>;

export function cdcaApiReducer(state: CdcaApiState = cdcaApiInicialState, action: CdcaApiAction): CdcaApiState {
  switch (action.type) {
    case CdcaApiActionType.Update:
      return { ...action.payload };
    case CdcaApiActionType.Reset:
      return { ...cdcaApiInicialState };
    default:
      return state;
  }
}
